import { authConfig } from "../apiConfig";

// for get all combined Employee reports
export const get_combined_employee_reports_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`combinedEmployeeUtilizationReport`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// for get all completed Employee reports
export const get_employee_reports_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`EmployeeReport`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};
// for get all codumentation engineers kpi reports
export const get_documentation_engineers_reports_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`documentEngineerKPI`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};
// for get all list AvailableEngineers
export const get_available_engineers = async (data) => {
    try {
        const response = await authConfig.post(`listAvailableEngineers`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

